import { useState, useEffect } from "react";
import { 
  subscribeToTasks, 
  addTask, 
  updateTask, 
  deleteTask, 
  toggleTaskComplete,
  ensureWeeklyTouchTasks
} from "../services/tasksService";

export function useTasks() {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let unsubscribe = () => {};

    try {
      setLoading(true);
      unsubscribe = subscribeToTasks((data, err) => {
        if (err) {
          setError("Failed to load tasks.");
        } else {
          setTasks(data);
          setError("");
        }
        setLoading(false);
      });
    } catch (err) {
      console.error(err);
      setError("Failed to initialize tasks subscription.");
      setLoading(false);
    }

    return () => unsubscribe();
  }, []);

  const handleAddTask = async (data) => {
    try {
      setError("");
      return await addTask(data);
    } catch (err) {
      console.error("Error adding task:", err);
      setError(err.message || "Failed to add task.");
      throw err;
    }
  };

  const handleUpdateTask = async (id, data) => {
    try {
      setError("");
      await updateTask(id, data);
    } catch (err) {
      console.error("Error updating task:", err);
      setError(err.message || "Failed to update task.");
      throw err;
    }
  };

  const handleToggleComplete = async (id, currentStatus, completedBy = "") => {
    try {
      setError("");
      await toggleTaskComplete(id, currentStatus, completedBy);
    } catch (err) {
      console.error("Error toggling task completion:", err);
      setError(err.message || "Failed to toggle task.");
      throw err;
    }
  };

  const handleDeleteTask = async (id) => {
    try {
      setError("");
      await deleteTask(id);
    } catch (err) {
      console.error("Error deleting task:", err);
      setError(err.message || "Failed to delete task.");
      throw err;
    }
  };

  return {
    tasks,
    loading,
    error,
    setError,
    addTask: handleAddTask,
    updateTask: handleUpdateTask,
    toggleTaskComplete: handleToggleComplete,
    deleteTask: handleDeleteTask,
    ensureWeeklyTouchTasks
  };
}
